export default __webpack_public_path__ + "static/portal-430fd04d12744a7cfddac1b1682f760e.png";